import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=9f7d856a&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f7d856a')) {
      api.createRecord('9f7d856a', component.options)
    } else {
      api.reload('9f7d856a', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=9f7d856a&", function () {
      api.rerender('9f7d856a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4CeaWegSqLq1y/JS/videoIframe.vue"
export default component.exports